module.exports = __webpack_public_path__ + "static/media/buildingOff_118.c0788d77.png";